import {
  Flex, Box, SimpleGrid, Image,
} from "@chakra-ui/react";
import React from "react";
import { StyleSheet, css } from "aphrodite";
import { useSelector } from "react-redux";


function Sponsors() {
    const isMobile = useSelector(state=> state.windowSize.isMobile);

    const ColNum = isMobile ? 2 : 3;
    return (
    <>
      <Box className={css(styles.head)} width='80%' marginLeft="10%" marginRight="10%">
          <Flex className={css(styles.container)}>
              NEXTCON Lab & SCVIC CENTRE SPONSORS 
          </Flex>
          <SimpleGrid columns={ColNum} spacing={5} textAlign="center" marginTop={5} marginBottom={5}>
              <Box justifyContent="center" alignContent="center">
                  <Flex justifyContent="center">
                    <Image src="sponsors 1.png" alt="" className={css(styles.images)} />
                  </Flex>
              </Box>
              <Box justifyContent="center" alignContent="center">
                  <Flex justifyContent="center">
                      <Image src="sponsors 2.png" alt="" className={css(styles.images)} />
                  </Flex>
              </Box>
              <Box justifyContent="center" alignContent="center">
                  <Flex justifyContent="center">
                      <Image src="Mitacs Media Kit_ Resources for Media____.png" alt="" className={css(styles.images)} />
                  </Flex>
              </Box>
              <Box justifyContent="center" alignContent="center">
                  <Flex justifyContent="center">
                      <Image src="sponsors 4.png" alt="" className={css(styles.images)} />
                  </Flex>
              </Box>
              <Box justifyContent="center" alignContent="center">
                  <Flex justifyContent="center">
                      <Image src="ORF.jpg" alt="" className={css(styles.images)} />
                  </Flex>
              </Box>
              <Box justifyContent="center" alignContent="center">
                  <Flex justifyContent="center">
                      <Image src="sponsors 5.png" alt="" className={css(styles.images)} />
                  </Flex>
              </Box>
              <Box justifyContent="center" alignContent="center">
                  <Flex justifyContent="center">
                      <Image src="sponsors 6.png" alt="" className={css(styles.images)} width='70%' />
                  </Flex>
              </Box>
              <Box justifyContent="center" alignContent="center">
                  <Flex justifyContent="center">
                      <Image src="sponsors 7.jpg" alt="" className={css(styles.images)} />
                  </Flex>
              </Box>
          </SimpleGrid>
      </Box>
    </>
    );
  }

  const styles = StyleSheet.create({
    head: {
        maxWidth: '100vw',
        marginTop: 0
    },
    parent: {
        maxWidth: '100vw',
        textAlign: 'center'
    },
    container: {
        maxWidth: '100%',
        justifyContent: 'center',
        fontSize: 30,
        margin: '1%',
        fontWeight: 'bolder',
        textShadow: '1px 1px gray',
        textAlign: 'center',
        textDecorationLine: 'underline'
    },
    textbox: {
        margin: '2%',
        marginTop: '0%',
        textAlign: 'center',
        fontSize: 18,
        justifyContent: 'center',
        alignContent: 'center'
    },
    names: {
        fontWeight: 'bold',
        fontSize: 20
    },
    title: {
        fontSize: 18,
    },
    images: {
        fit: "fit",
    },
    mobileImage: {
        width: "70%",
        borderRadius: "80%"
    }
})


  export default Sponsors;